import React from 'react';

const Header = () => (
  <div className="text-center max-w-5xl mx-auto px-6 sm:px-8 lg:px-10 bg-gradient-to-r from-purple-700 to-blue-600 text-white py-20 rounded-lg shadow-2xl">
    <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold mb-8 leading-tight">
      🌟 Full Stack Development Course
    </h1>
    <p className="text-xl sm:text-2xl mt-6">
      Master Web Development in 6 Months with Industry Experts
    </p>
    <p className="text-lg sm:text-xl mt-4">
      🚀 <strong>Starting from: April 09, 2025</strong>
    </p>
    <div className="mt-10">
      <a
        href="#enroll"
        className="inline-block bg-white text-blue-600 font-bold py-4 px-8 rounded-lg shadow-lg hover:bg-gray-100 transition-transform transform hover:scale-105"
      >
        Enroll Now
      </a>
    </div>
  </div>
);

export default Header;
